// Flat key -> string dictionaries for the two supported UI languages.
// t(key, vars) in LanguageContext.js falls back to English, then to the raw key,
// so a missing Bulgarian entry never breaks the page.
export const translations = {
  en: {
    "nav.shop": "Shop",
    "nav.dashboard": "Dashboard",
    "nav.products": "Products",
    "nav.addProduct": "Add Product",
    "nav.orders": "Orders",
    "nav.login": "Login",
    "nav.logout": "Logout",
    "nav.cart": "Cart",

    "footer.tagline":
      "Single-origin honey, bottled by the harvest — nothing blended, nothing standardized to taste the same year over year.",
    "footer.shop": "Shop",
    "footer.allHoney": "All honey",
    "footer.cart": "Cart",
    "footer.support": "Support",
    "footer.contact": "Contact",
    "footer.admin": "Admin",
    "footer.follow": "Follow",

    "home.eyebrow": "Single-origin honey",
    "home.headline": "Every jar tastes like somewhere specific.",
    "home.subhead":
      "We grade each harvest by floral source, color, and batch — like a wine list, not a snack aisle.",
    "home.cta": "Shop the harvest",
    "home.featured": "This week's harvest",

    "products.title": "All honey",
    "products.adminTitle": "Admin Products List",
    "products.empty": "No honey listed yet — check back soon.",

    "product.loading": "Loading...",
    "product.notFound": "That honey couldn't be found.",
    "product.breadcrumbShop": "Shop",
    "product.rawUnfiltered": "Raw & unfiltered",
    "product.qty": "Qty",
    "product.add": "Add",
    "product.edit": "Edit",
    "product.addToCart": "Add to cart",
    "product.deliveryTitle": "Delivery",
    "product.deliveryText": "Flat $4.99 delivery, dispatched within 2 business days.",
    "product.storageTitle": "Storage",
    "product.storageText": "Store at room temperature. Natural crystallization is normal, not a flaw.",

    "cart.title": "Your cart",
    "cart.empty": "Your cart is empty.",
    "cart.shopHoney": "Shop honey",
    "cart.remove": "Remove",
    "cart.subtotal": "Subtotal",
    "cart.delivery": "Delivery",
    "cart.total": "Total",
    "cart.proceed": "Proceed to checkout",

    "checkout.title": "Checkout",
    "checkout.emptyCart": "Your cart is empty — add some honey before checking out.",
    "checkout.step.address": "Address",
    "checkout.step.payment": "Payment",
    "checkout.step.confirmation": "Confirmation",
    "checkout.genericError": "Something went wrong placing your order. Please try again.",

    "address.title": "Contact & Delivery Address",
    "address.name": "Full Name",
    "address.email": "Email",
    "address.street": "Street Address",
    "address.city": "City",
    "address.zip": "ZIP / Postal Code",
    "address.incomplete": "Please fill in all fields.",
    "address.continue": "Continue to Payment",

    "payment.title": "Choose payment method",
    "payment.card": "Credit / Debit card",
    "payment.paypal": "PayPal",
    "payment.cod": "Cash on delivery",
    "payment.totalDue": "Total due:",
    "payment.back": "Back",
    "payment.placing": "Placing order...",
    "payment.placeOrder": "Place order — {amount}",

    "confirmation.title": "Order placed.",
    "confirmation.thanks": "Thanks, {name} — a confirmation is on its way to your inbox.",
    "confirmation.order": "Order",
    "confirmation.delivery": "Delivery",
    "confirmation.deliveringTo": "Delivering to",
    "confirmation.payment": "Payment",
    "confirmation.total": "Total",
    "confirmation.keepShopping": "Keep shopping",

    "adminLogin.title": "Admin Login",
    "adminLogin.email": "Email",
    "adminLogin.password": "Password",
    "adminLogin.show": "Show",
    "adminLogin.hide": "Hide",
    "adminLogin.submit": "Login",
    "adminLogin.invalid": "Invalid email or password.",
    "adminLogin.notAdmin": "This account doesn't have admin access.",

    "adminOrders.title": "Orders for {date}",
    "adminOrders.empty": "No orders found for this date.",

    "adminDashboard.title": "Admin Dashboard",
    "adminDashboard.saved": "✅ Product was successfully saved!",

    "notFound.title": "404 — Not found",
    "notFound.text": "This page doesn't exist.",
    "notFound.backHome": "Back to home",
  },

  bg: {
    "nav.shop": "Магазин",
    "nav.dashboard": "Табло",
    "nav.products": "Продукти",
    "nav.addProduct": "Добави продукт",
    "nav.orders": "Поръчки",
    "nav.login": "Вход",
    "nav.logout": "Изход",
    "nav.cart": "Количка",

    "footer.tagline":
      "Мед от единствен произход, бутилиран според реколтата — без смесване, без стандартизиране на вкуса от година в година.",
    "footer.shop": "Магазин",
    "footer.allHoney": "Всички видове мед",
    "footer.cart": "Количка",
    "footer.support": "Поддръжка",
    "footer.contact": "Контакт",
    "footer.admin": "Администратор",
    "footer.follow": "Последвайте ни",

    "home.eyebrow": "Мед от единствен произход",
    "home.headline": "Всяко бурканче има вкус на конкретно място.",
    "home.subhead":
      "Класифицираме всяка реколта по цветен произход, цвят и партида — като винена карта, а не като рафт за закуски.",
    "home.cta": "Разгледай реколтата",
    "home.featured": "Реколтата на седмицата",

    "products.title": "Всички видове мед",
    "products.adminTitle": "Списък с продукти (админ)",
    "products.empty": "Все още няма добавен мед — проверете отново скоро.",

    "product.loading": "Зареждане...",
    "product.notFound": "Този мед не беше намерен.",
    "product.breadcrumbShop": "Магазин",
    "product.rawUnfiltered": "Суров и нефилтриран",
    "product.qty": "Кол.",
    "product.add": "Добави",
    "product.edit": "Редактирай",
    "product.addToCart": "Добави в количката",
    "product.deliveryTitle": "Доставка",
    "product.deliveryText": "Фиксирана доставка от $4.99, изпращане до 2 работни дни.",
    "product.storageTitle": "Съхранение",
    "product.storageText": "Съхранявайте при стайна температура. Естествената кристализация е нормална, не е дефект.",

    "cart.title": "Вашата количка",
    "cart.empty": "Количката ви е празна.",
    "cart.shopHoney": "Разгледай мед",
    "cart.remove": "Премахни",
    "cart.subtotal": "Междинна сума",
    "cart.delivery": "Доставка",
    "cart.total": "Общо",
    "cart.proceed": "Продължи към плащане",

    "checkout.title": "Плащане",
    "checkout.emptyCart": "Количката ви е празна — добавете мед преди да продължите.",
    "checkout.step.address": "Адрес",
    "checkout.step.payment": "Плащане",
    "checkout.step.confirmation": "Потвърждение",
    "checkout.genericError": "Възникна проблем при подаването на поръчката. Моля, опитайте отново.",

    "address.title": "Данни за контакт и адрес за доставка",
    "address.name": "Име и фамилия",
    "address.email": "Имейл",
    "address.street": "Адрес (улица)",
    "address.city": "Град",
    "address.zip": "Пощенски код",
    "address.incomplete": "Моля, попълнете всички полета.",
    "address.continue": "Продължи към плащане",

    "payment.title": "Изберете начин на плащане",
    "payment.card": "Кредитна / Дебитна карта",
    "payment.paypal": "PayPal",
    "payment.cod": "Наложен платеж",
    "payment.totalDue": "Дължима сума:",
    "payment.back": "Назад",
    "payment.placing": "Изпращане на поръчката...",
    "payment.placeOrder": "Направи поръчка — {amount}",

    "confirmation.title": "Поръчката е направена.",
    "confirmation.thanks": "Благодарим, {name} — потвърждение пристига във вашата поща.",
    "confirmation.order": "Поръчка",
    "confirmation.delivery": "Доставка",
    "confirmation.deliveringTo": "Доставка до",
    "confirmation.payment": "Плащане",
    "confirmation.total": "Общо",
    "confirmation.keepShopping": "Продължи пазаруването",

    "adminLogin.title": "Вход за администратор",
    "adminLogin.email": "Имейл",
    "adminLogin.password": "Парола",
    "adminLogin.show": "Покажи",
    "adminLogin.hide": "Скрий",
    "adminLogin.submit": "Вход",
    "adminLogin.invalid": "Невалиден имейл или парола.",
    "adminLogin.notAdmin": "Този акаунт няма администраторски достъп.",

    "adminOrders.title": "Поръчки за {date}",
    "adminOrders.empty": "Няма намерени поръчки за тази дата.",

    "adminDashboard.title": "Администраторско табло",
    "adminDashboard.saved": "✅ Продуктът беше запазен успешно!",

    "notFound.title": "404 — Не е намерено",
    "notFound.text": "Тази страница не съществува.",
    "notFound.backHome": "Начало",
  },
};
